import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 14",
  stroke: "white"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M13.1996 7C13.1996 7.8142 13.0392 8.62042 12.7276 9.37265C12.4161 10.1249 11.9594 10.8083 11.3837 11.3841C10.808 11.9598 10.1245 12.4165 9.37233 12.7281C8.62014 13.0396 7.81395 13.2 6.99978 13.2C6.18562 13.2 5.37943 13.0396 4.62724 12.7281C3.87505 12.4165 3.19159 11.9598 2.61588 11.3841C2.04018 10.8083 1.5835 10.1249 1.27193 9.37264C0.960363 8.62042 0.8 7.8142 0.8 7C0.8 6.1858 0.960364 5.37957 1.27193 4.62735C1.5835 3.87513 2.04018 3.19165 2.61588 2.61593C3.19159 2.04021 3.87505 1.58352 4.62724 1.27194C5.37943 0.960366 6.18562 0.8 6.99978 0.8C7.81395 0.8 8.62014 0.960367 9.37233 1.27194C10.1245 1.58352 10.808 2.04021 11.3837 2.61593C11.9594 3.19165 12.4161 3.87514 12.7276 4.62736C13.0392 5.37958 13.1996 6.1858 13.1996 7L13.1996 7Z",
      "stroke-opacity": "0.2",
      "stroke-width": "1.6",
      fill: "none"
    }, null, -1),
    _createElementVNode("path", {
      d: "M6.99978 0.8C8.22598 0.8 9.42464 1.16362 10.4442 1.84488C11.4637 2.52614 12.2584 3.49445 12.7276 4.62735C13.1969 5.76026 13.3197 7.00688 13.0804 8.20956C12.8412 9.41225 12.2507 10.517 11.3837 11.3841C10.5166 12.2512 9.41193 12.8416 8.2093 13.0809C7.00666 13.3201 5.7601 13.1973 4.62724 12.7281C3.49438 12.2588 2.5261 11.4641 1.84486 10.4445C1.16361 9.42496 0.8 8.22625 0.8 7",
      "stroke-width": "1.6",
      "stroke-linecap": "round",
      fill: "none"
    }, null, -1)
  ]))]))
}
export default { render: render }